import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { FixedSizeList as List } from 'react-window';
import { Link, useHistory } from 'react-router-dom';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';

function Stock() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [hasMore, setHasMore] = useState(true);
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [isLoading, setIsLoading] = useState(false);

    // const { isAuthenticated, companyId } = useAuth();
    const [loading, setLoading] = useState(false);
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const hasReadReportPermission = permissions.includes('Read Reports');


    useEffect(() => {

        fetchtableData();

    }, []);

    // const fetchtableData = async () => {
    //     if (hasReadReportPermission) {
    //         fetchData('StockReportApi', `/${companyId}`, token)
    //             .then((response) => {
    //                 if (response.responseCode == '1111') {
    //                     console.log(response);
    //                     setData(response.response_data);
    //                 }
    //             })
    //             .catch((error) => {
    //                 console.error('Error fetching STOCK Details:', error);
    //             });
    //     }
    // };

    const fetchtableData = async () => {
        try {
            const response = await fetchData('StockReportApi', `/${companyId}`, token);
            console.log('API Response:', response);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                setHasMore(response.response_data.length > 0);
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
    };

    //handle search

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );



    // useEffect(() => {

    //     refreshData();

    // }, []);

    //search
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Stock Report</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Stock Report</h3>');
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">HSNCode</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Code</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Name</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Opening</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Total</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Current</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Minimum</th>');

        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        data.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${index + 1}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.HSNCode}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Code}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Name}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.OpeningStock}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.TotalStock}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CurrentStock}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.MinimumStock}</td>`);

            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };

    //excel

    const handleExportExcel = () => {
        const excelData = [];

        // Add header row
        const headerRow = [
            'Sl.No',
            'HSNCode',
            'Code',
            'Name',
            'OpeningStock',
            'TotalStock',
            'CurrentStock',
            'MinimumStock'
        ];
        excelData.push(headerRow);
        // Add data rows
        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1,
                rowData.HSNCode,
                rowData.Code,
                rowData.Name,
                rowData.OpeningStock,
                rowData.TotalStock,
                rowData.CurrentStock,
                rowData.MinimumStock,

            ];
            excelData.push(dataRow);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Stock Report');

        // Save workbook to a file
        XLSX.writeFile(wb, 'StockReport.xlsx');
    };



    const getRowColor = (totalStock, minimumStock) => {
        if (totalStock === minimumStock) {
            return { backgroundColor: 'salmon' };
        }
        return {}; // Default style
    };

    const Row = useCallback(({ index, style }) => {
        const item = filteredData[index];
        return (
            <TableRow key={item.id} sx={getRowColor(item.TotalStock, item.MinimumStock)} style={style}>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'left', fontSize: '13px' }}>{index + 1}</TableCell>

                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'center', fontSize: '13px' }}>{item.Code}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'left', fontSize: '13px', width: '600px' }}>{item.Name}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'center', fontSize: '13px', width: '150px' }}>{item.HSNCode}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'center', fontSize: '13px', width: '150px' }}>{item.OpeningStock}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'center', fontSize: '13px', width: '150px' }}>{item.TotalStock}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'center', fontSize: '13px', width: '150px' }}>{item.CurrentStock}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'center', fontSize: '13px', width: '150px' }}>{item.MinimumStock}</TableCell>
            </TableRow>
        )
    }, [filteredData]);


    const [isFocused, setIsFocused] = useState(false);


    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder', marginTop: '10px', fontSize: '17px' }}>STOCK DETAILS </h6>
            <div className="flex justify-end" style={{ marginTop: '-15px' }}>
                <Button onClick={handleExportExcel} style={{ background: '#dc3545', color: 'whitesmoke', fontWeight: 'bolder', height: '35px' }} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Excel"}
                </Button>
                <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{
                        width: isFocused ? '250px' : '200px',
                        transition: 'width 0.3s ease, box-shadow 0.3s ease',
                        padding: '10px 15px',
                        border: '1px solid #ccc',
                        borderRadius: '25px',
                        outline: 'none',
                        marginLeft: '5px',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : '0 2px 5px rgba(0, 0, 0, 0.1)',
                    }}
                />
            </div>


            <div className='w-full mb-5 flex' style={{ overflowY: 'auto', Width: '2500px', marginTop: '5px', height: '480px' }}>

                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textAlign: 'left', color: 'white',textTransform:'uppercase' }}>
                                    <span style={{ marginLeft: '-5px' }}>Sl.No</span>
                                    <span style={{ marginLeft: '50px', color: 'white', fontWeight: 'bolder' }}>Code</span>
                                    <span style={{ marginLeft: '95px', color: 'white', fontWeight: 'bolder' }}>Name</span>
                                    <span style={{ marginLeft: '490px', color: 'white', fontWeight: 'bolder' }}>HSN</span>

                                    <span style={{ marginLeft: '75px', color: 'white', fontWeight: 'bolder' }}>Opening</span>
                                    <span style={{ marginLeft: '70px', color: 'white', fontWeight: 'bolder' }}>Current</span>
                                    <span style={{ marginLeft: '90px', color: 'white', fontWeight: 'bolder' }}>M.Stock</span>
                                    <span style={{ marginLeft: '100px', color: 'white', fontWeight: 'bolder' }}>T.Stock</span>

                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <List
                                height={500}
                                itemCount={filteredData.length}
                                itemSize={60}
                                width="100%"
                            >
                                {Row}
                            </List>
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>

        </div >

    );
}

export default Stock;

